import { Box } from "@mantine/core";
import { isTestRealm, setTestRealm } from "@/utils/country";

const TestRealmIndicator = () => {
  const handleDoubleClick = () => {
    setTestRealm(false);
    window.location.reload();
  };

  if (!isTestRealm()) {
    return null;
  }

  return (
    <Box
      style={{
        position: "fixed",
        top: "10px",
        left: "10px",
        zIndex: 9999,
        backgroundColor: "#ff6b6b",
        color: "white",
        padding: "8px 12px",
        borderRadius: "4px",
        fontSize: "12px",
        fontWeight: "bold",
        cursor: "pointer",
        userSelect: "none",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      }}
      onDoubleClick={handleDoubleClick}
      title="Double-click to disable test realm"
    >
      Test Realm
    </Box>
  );
};

export default TestRealmIndicator;
